<template>
  <footer>
    <div class="footer-inner">
      <template v-if="isFinance">
        <span>Art Finance · artrofimov.xyz · Amsterdam</span>
        <span>
          Not financial advice. Structural measurement, not prediction.
          <span style="margin-left: 10px">
            <router-link to="/live">Live scores</router-link>
            <span style="opacity: 0.6">&nbsp;&nbsp;</span>
            <a href="https://artrofimov.xyz">← Main site</a>
          </span>
        </span>
      </template>
      <template v-else>
        <span>Art · Structural Health Monitoring · Amsterdam</span>
        <span>Measurement instrument, not prediction system.</span>
      </template>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const isFinance = computed(() => {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'finance.artrofimov.xyz'
})
</script>